import { render, staticRenderFns } from "./PaidRejected.vue?vue&type=template&id=884c32b2&"
import script from "./PaidRejected.vue?vue&type=script&lang=js&"
export * from "./PaidRejected.vue?vue&type=script&lang=js&"
import style0 from "./PaidRejected.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports